module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/guest_list-7a9b1195630fe9da0897786e3ce2fdaf.jpg";